const regex = {
  "geneticConsentInitial": /^[a-zA-Z]\.?[a-zA-Z](\.?[a-zA-Z])*\.?$/,
  "geneticReleaseInitial": /^[a-zA-Z]\.?[a-zA-Z](\.?[a-zA-Z])*\.?$/,
 }
 export default regex